module.exports = __webpack_public_path__ + "img/630.d5cbf341.jpg";